export const servicesData = [
  {
    name: 'Private Limited Company Registration',
    slug: 'private-limited-company-registration',
    description: 'Incorporate your Private Limited Company online in 7–10 days with expert CA guidance.',
    price: 8999,
    category: 'registration',
    isActive: true,
    benefits: [
      'Limited Liability Protection: Personal assets are 100% safe from business liabilities.',
      'Easy External Funding: Venture capitalists and angel investors prefer investing in Pvt Ltd companies.',
      'Separate Legal Entity: The company can own property and sign contracts in its own name.',
      'Builds Brand Credibility: Registering increases client trust and vendor credentials.',
      '100% Online Process: Zero physical office visits. We handle all filings on your behalf.',
      'PAN & TAN Included: Get your corporate tax registration numbers automatically.'
    ],
    process: [
      { step: 1, title: 'Name Approval', description: 'Reserve your company name with MCA using the RUN service. Timeline: 1-2 days.' },
      { step: 2, title: 'Obtain DSC & DIN', description: 'Acquire Digital Signature Certificates and Director Identification Numbers. Timeline: 1 day.' },
      { step: 3, title: 'Draft MOA & AOA', description: 'Draft Memorandum & Articles of Association specifying business guidelines. Timeline: 1 day.' },
      { step: 4, title: 'SPICe+ Form Filing', description: 'Submit integrated incorporation application with MCA. Timeline: 2-3 days.' },
      { step: 5, title: 'Receive Certificate', description: 'Receive Certificate of Incorporation, corporate PAN, TAN, and bank details. Timeline: 2 days.' }
    ],
    documents: [
      'PAN Card (all directors)',
      'Aadhaar Card (all directors)',
      'Proof of address for all directors (Bank statement / Utility bill)',
      'Registered office address proof (Electricity bill / Rent agreement)',
      'Passport-size photographs'
    ],
    faqs: [
      { question: 'What is the minimum capital required for Pvt Ltd?', answer: 'There is no minimum authorized capital requirement. You can start with as low as ₹10,000.' },
      { question: 'Can an NRI become a director?', answer: 'Yes, an NRI or foreign national can become a director, but at least one director must be an Indian resident.' },
      { question: 'What are the annual compliance requirements?', answer: 'Pvt Ltd companies must file annual returns, financial statements, and hold regular board meetings.' }
    ],
    seo: {
      title: 'Private Limited Company Registration Online India | MSMECenter',
      description: 'Register your Pvt Ltd company online in 7-10 working days. Free consultation, transparent pricing, inclusive of government fees.'
    },
    governmentFee: 4000,
    serviceCharge: 4999,
    popular: true
  },
  {
    name: 'LLP Registration',
    slug: 'llp-registration',
    description: 'Form a Limited Liability Partnership (LLP) combining company benefits with partnership flexibility.',
    price: 6999,
    category: 'registration',
    isActive: true,
    benefits: [
      'Partners get limited liability protecting their personal estates.',
      'Lower compliance cost compared to Private Limited companies.',
      'No audit required if turnover is under ₹40 Lakhs and capital is under ₹25 Lakhs.',
      'Flexible internal structure governed by the mutual LLP agreement.',
      'Separate legal identity for ease of operations and agreements.'
    ],
    process: [
      { step: 1, title: 'Partner DSC', description: 'Secure Digital Signature Certificates for designated partners. Timeline: 1 day.' },
      { step: 2, title: 'Name Reservation', description: 'Submit name choice through RUN-LLP on MCA portal. Timeline: 2 days.' },
      { step: 3, title: 'FiLLiP Filing', description: 'File incorporation documents with MCA registry. Timeline: 3 days.' },
      { step: 4, title: 'Agreement Drafting', description: 'Draft and execute the LLP partnership agreement. Timeline: 2 days.' },
      { step: 5, title: 'File Agreement', description: 'Submit LLP Agreement (Form 3) to MCA within 30 days of registration. Timeline: 1 day.' }
    ],
    documents: [
      'PAN Card of all partners',
      'Aadhaar / Voter ID of all partners',
      'Electricity bill of registered office',
      'No Objection Certificate (NOC) from landlord',
      'Partnership agreement draft'
    ],
    faqs: [
      { question: 'How many partners are required for an LLP?', answer: 'A minimum of 2 partners is required. There is no limit on the maximum number of partners.' },
      { question: 'Is an LLP better than a Partnership firm?', answer: 'Yes. Partnerships have unlimited liability, whereas LLP partners have limited liability protecting personal assets.' }
    ],
    seo: {
      title: 'LLP Registration Online – Limited Liability Partnership | MSMECenter',
      description: 'Register your LLP in India online. Expert CA assistance, transparent billing, and zero hidden charges. Form your partnership today.'
    },
    governmentFee: 3000,
    serviceCharge: 3999,
    popular: false
  },
  {
    name: 'GST Registration',
    slug: 'gst-registration',
    description: 'Get your GSTIN number quickly in 3–5 working days to claim Input Tax Credit and make interstate sales.',
    price: 799,
    category: 'registration',
    isActive: true,
    benefits: [
      'Mandatory for businesses with annual turnover exceeding ₹20 Lakhs (₹10 Lakhs in hill states).',
      'Enables claiming of Input Tax Credit (ITC) on business expenses and asset buys.',
      'Legally allows interstate supply of goods and services.',
      'Compulsory for registering as a seller on Amazon, Flipkart, or government e-marketplaces.',
      'Builds credibility with suppliers and corporate clients.'
    ],
    process: [
      { step: 1, title: 'Submit Documents', description: 'Share basic business proofs, Aadhaar, and bank particulars. Timeline: 1 hour.' },
      { step: 2, title: 'Portal Filing', description: 'Our team registers and files your application on the GSTN portal. Timeline: 1 day.' },
      { step: 3, title: 'ARN Generation', description: 'Receive your Application Reference Number to track status. Timeline: 1 day.' },
      { step: 4, title: 'Officer Verification', description: 'GST officer reviews and approves documents. Timeline: 2-3 days.' },
      { step: 5, title: 'Get GSTIN', description: 'Receive your official GST Registration Certificate (Form REG-06). Timeline: 1 day.' }
    ],
    documents: [
      'PAN Card of applicant',
      'Aadhaar Card',
      'Business address proof (Rent agreement / Electricity bill)',
      'Cancelled cheque or bank statement',
      'Promoter photograph'
    ],
    faqs: [
      { question: 'Is there a penalty for not registering?', answer: 'Yes. Failure to register when mandatory attracts a 100% tax penalty or ₹10,000, whichever is higher.' },
      { question: 'Can I opt for voluntary GST registration?', answer: 'Yes, voluntary registration is allowed and beneficial for claiming tax credits.' }
    ],
    seo: {
      title: 'GST Registration Online – Apply for GSTIN in 3 Days | MSMECenter',
      description: 'Apply for your GST number online. Expert support, zero paperwork, and instant activation. Clear your tax compliance easily.'
    },
    governmentFee: 0,
    serviceCharge: 799,
    popular: true
  },
  {
    name: 'Udyam Registration',
    slug: 'udyam-registration',
    description: 'Get your official MSME registration certificate online to unlock government subsidies and lower interest rates.',
    price: 499,
    category: 'registration',
    isActive: true,
    benefits: [
      'Enjoy priority sector lending: Business loans at lower interest rates.',
      'Collateral-free credit schemes like CGTMSE under Udyam cover.',
      'Protection against delayed buyer payments: Mandatory 45 days settlement.',
      '50% discount on patent and trademark registration fees.',
      'Electricity bill concessions and tax subsidies for manufacturing units.'
    ],
    process: [
      { step: 1, title: 'Aadhaar Verification', description: 'Verify owner Aadhaar linked to active mobile. Timeline: 10 mins.' },
      { step: 2, title: 'Fill Business Details', description: 'Input investment figures, turnover, and employee counts. Timeline: 1 hour.' },
      { step: 3, title: 'NIC Code Mapping', description: 'Assign correct National Industrial Classification codes to your trade. Timeline: 2 hours.' },
      { step: 4, title: 'Submit Form', description: 'Submit registration application on the Udyam portal. Timeline: 1 hour.' },
      { step: 5, title: 'Get Certificate', description: 'Receive your PDF Udyam Registration Certificate. Timeline: 1-2 days.' }
    ],
    documents: [
      'Aadhaar card of promoter',
      'PAN card of owner / company',
      'GSTIN (if applicable)',
      'Bank account number & IFSC'
    ],
    faqs: [
      { question: 'What are the MSME investment limits?', answer: 'Micro: Investment < 1Cr & Turnover < 5Cr. Small: Investment < 10Cr & Turnover < 50Cr. Medium: Investment < 50Cr & Turnover < 250Cr.' },
      { question: 'Does the certificate expire?', answer: 'No, the Udyam Registration Certificate is valid for lifetime unless updated or cancelled.' }
    ],
    seo: {
      title: 'MSME Udyam Registration Online Certificate | MSMECenter',
      description: 'Get your MSME certificate online. Access government tenders, priority bank interest rates, and legal payment protection.'
    },
    governmentFee: 0,
    serviceCharge: 499,
    popular: true
  },
  {
    name: 'GST Return Filing',
    slug: 'gst-return-filing',
    description: 'Ensure accurate monthly, quarterly, and annual GST return filings to stay compliant and avoid massive penalties.',
    price: 999,
    category: 'compliance',
    isActive: true,
    benefits: [
      'Avoid high late fee penalties (up to ₹5,000 per missing return).',
      'Reconcile invoices with GSTR-2B to capture maximum Input Tax Credit.',
      'Accurate tax calculation preventing double payments or interest audits.',
      'Build a strong compliance rating to secure banking lines and loans.',
      'Seamless compliance reminders so you never miss a filing deadline.'
    ],
    process: [
      { step: 1, title: 'Invoice Upload', description: 'Upload purchase and sales bills to our dashboard. Timeline: 1 day.' },
      { step: 2, title: 'Data Reconciliation', description: 'We match bills with GSTR-2B to adjust tax credits. Timeline: 1 day.' },
      { step: 3, title: 'Draft Return', description: 'We prepare GSTR-1 and GSTR-3B forms for your approval. Timeline: 1 day.' },
      { step: 4, title: 'Filing & Payment', description: 'File return on GST portal and process tax payments. Timeline: 1 day.' },
      { step: 5, title: 'Filing Receipt', description: 'Share ARN receipt and tax challans for your records. Timeline: 1 day.' }
    ],
    documents: [
      'Sales register / sales invoices',
      'Purchase register / purchase invoices',
      'Debit & credit notes',
      'GST portal credentials (if available)'
    ],
    faqs: [
      { question: 'What is the penalty for late GST filing?', answer: 'A late fee of ₹50/day (₹20/day for NIL returns) plus 18% p.a. interest on delayed tax liability.' },
      { question: 'What is GSTR-1 and GSTR-3B?', answer: 'GSTR-1 collects details of sales made, while GSTR-3B calculates summary tax payable after ITC adjustments.' }
    ],
    seo: {
      title: 'GST Return Filing Services Online – Monthly & Quarterly | MSMECenter',
      description: 'File GSTR-1, GSTR-3B, and GSTR-9 returns with CA supervision. Avoid late fees, claim accurate tax credits, and secure compliance.'
    },
    governmentFee: 0,
    serviceCharge: 999,
    popular: true
  },
  {
    name: 'Income Tax Return Filing',
    slug: 'income-tax-return-filing',
    description: 'Professional CA-assisted filing of ITR-1 to ITR-6. Claim eligible deductions and maximum refunds.',
    price: 1299,
    category: 'compliance',
    isActive: true,
    benefits: [
      'Legally claim maximum tax deductions under sections 80C, 80D, 80G, etc.',
      'Fast-track loan approvals: Banks demand 3 years of ITR returns.',
      'Avoid high penalties (up to ₹5,000 for late filings) and income tax notices.',
      'Carry forward capital losses against future capital gains.',
      'Legitimate proof of income for passport and visa applications.'
    ],
    process: [
      { step: 1, title: 'Collect Salary & Bank Info', description: 'Submit Form 16, salary slips, and interest statements. Timeline: 1 hour.' },
      { step: 2, title: 'Analyze Deductions', description: 'CA matches investment proofs and recommends deductions. Timeline: 1 day.' },
      { step: 3, title: 'ITR Choice & Draft', description: 'Select the right ITR form (ITR-1 to ITR-4) and draft details. Timeline: 1 day.' },
      { step: 4, title: 'File on e-Portal', description: 'File ITR with the IT department. Timeline: 1 day.' },
      { step: 5, title: 'E-Verification', description: 'Confirm your filing using Aadhaar OTP e-verification. Timeline: 1 day.' }
    ],
    documents: [
      'Form 16 (for salaried)',
      'Bank account statements (last 12 months)',
      'Investment receipts (LIC, PPF, ELSS)',
      'PAN and Aadhaar card'
    ],
    faqs: [
      { question: 'What is the due date for ITR filing?', answer: 'July 31st for individuals and non-audit cases. October 31st for audited businesses.' },
      { question: 'Can I file ITR even if my income is under the tax slab?', answer: 'Yes, filing a NIL return is highly recommended as income proof for loans and visas.' }
    ],
    seo: {
      title: 'Income Tax Return Filing Online – CA Assisted ITR | MSMECenter',
      description: 'Get ITR filed by certified chartered accountants. Secure maximum tax refunds, prevent errors, and stay compliant with Income Tax rules.'
    },
    governmentFee: 0,
    serviceCharge: 1299,
    popular: true
  },
  {
    name: 'Accounting & Bookkeeping',
    slug: 'accounting',
    description: 'Professional, hassle-free corporate bookkeeping, ledger management, and financial statement drafting.',
    price: 4999,
    category: 'compliance',
    isActive: true,
    benefits: [
      'Maintain error-free, up-to-date ledgers using cloud software.',
      'Get CA-approved Profit & Loss and Balance Sheet statements.',
      'Stay ready for banking reviews, tax audits, and funding diligence.',
      'Save money by outsourcing accounting rather than hiring full-time staff.',
      'Track cash flows and expenses easily on monthly reports.'
    ],
    process: [
      { step: 1, title: 'Share Bank Statements', description: 'Provide bank and cash ledger outputs. Timeline: 1 hour.' },
      { step: 2, title: 'Categorize Transactions', description: 'We sort revenues, costs, capital buys and tax payments. Timeline: 2 days.' },
      { step: 3, title: 'Reconciliation', description: 'Reconcile accounts with credit card and supplier reports. Timeline: 2 days.' },
      { step: 4, title: 'Draft Statements', description: 'Prepare ledger sheets and financial summaries. Timeline: 2 days.' },
      { step: 5, title: 'Review & Deliver', description: 'Final review by accountant and monthly delivery of sheets. Timeline: 1 day.' }
    ],
    documents: [
      'Bank statement (PDF/Excel)',
      'Sales and purchase invoices',
      'Credit card statements',
      'Expense receipts'
    ],
    faqs: [
      { question: 'Is my financial data secure?', answer: 'Yes. We sign non-disclosure agreements and host bookkeeping files on 256-bit encrypted secure servers.' },
      { question: 'Which accounting software do you use?', answer: 'We specialize in Tally Prime, QuickBooks Online, and Zoho Books.' }
    ],
    seo: {
      title: 'Online Bookkeeping & Accounting Services India | MSMECenter',
      description: 'Outsource your accounting to experts. Get accurate balance sheets, ledger entries, and monthly P&L statements with CA supervision.'
    },
    governmentFee: 0,
    serviceCharge: 4999,
    popular: false
  },
  {
    name: 'Payroll Management',
    slug: 'payroll',
    description: 'Process salaries, structure CTCs, and manage PF, ESIC, and Professional Tax compliance online.',
    price: 2999,
    category: 'compliance',
    isActive: true,
    benefits: [
      'Accurate salary calculations including TDS deductions and bonuses.',
      'Guaranteed compliance with EPF, ESIC, and Professional Tax laws.',
      'Automated slip generation sent directly to employees.',
      'Saves HR time allowing focus on core team talent.',
      'Secure portal showing payroll costs and compliance liabilities.'
    ],
    process: [
      { step: 1, title: 'Setup CTC Structure', description: 'Design salary breakdown (Basic, HRA, LTA, PF). Timeline: 2 days.' },
      { step: 2, title: 'Upload Attendance', description: 'Send employee presence and leave metrics. Timeline: 1 day.' },
      { step: 3, title: 'Process Payroll', description: 'Calculate gross salaries, deductions, and payouts. Timeline: 1 day.' },
      { step: 4, title: 'Filing Compliance', description: 'Submit PF/ESIC payments and challan filings. Timeline: 1 day.' },
      { step: 5, title: 'Slips Delivery', description: 'Generate and send payslips online. Timeline: 1 day.' }
    ],
    documents: [
      'Employee contract list / CTC sheets',
      'Attendance tracker log',
      'Company PF/ESIC credentials (if registered)',
      'Bank authorization detail'
    ],
    faqs: [
      { question: 'Is PF mandatory for all firms?', answer: 'EPF registration is mandatory once a firm has 20 or more employees.' },
      { question: 'What is Professional Tax?', answer: 'A state-level tax levied on salaried employees, deducted monthly by employers.' }
    ],
    seo: {
      title: 'Payroll Processing & Compliance Services Online | MSMECenter',
      description: 'Streamline payroll management. CA-assisted EPF and ESIC challan filing, payslip generation, and professional tax management.'
    },
    governmentFee: 0,
    serviceCharge: 2999,
    popular: false
  },
  {
    name: 'Trademark Registration',
    slug: 'trademark-registration',
    description: 'Secure exclusive ownership of your brand name, logo, slogan, and tagline from competitors.',
    price: 5499,
    category: 'legal',
    isActive: true,
    benefits: [
      'Exclusive usage rights: Competitors cannot copy your brand name or logo.',
      'Use the ™ symbol immediately after submitting the application.',
      'Valid for 10 years and can be renewed indefinitely.',
      'Legal recourse: Power to sue copycats and claim damages.',
      'Builds brand equity and valuation over time.'
    ],
    process: [
      { step: 1, title: 'Brand Search', description: 'Conduct a search in IP India registry to verify availability. Timeline: 2 hours.' },
      { step: 2, title: 'Class Matching', description: 'Identify appropriate trademark classes for your products. Timeline: 1 day.' },
      { step: 3, title: 'Drafting & Filing', description: 'Prepare authorization letter and file application on IP portal. Timeline: 1 day.' },
      { step: 4, title: 'TM Application Receipt', description: 'Receive application number and start using ™ sign. Timeline: 1 day.' },
      { step: 5, title: 'Registration Certificate', description: 'Get official registration after publication in journal. Timeline: 12-18 months.' }
    ],
    documents: [
      'Brand logo / Brand name text',
      'Signed authorization letter (we prepare)',
      'Udyam Certificate (to claim 50% govt fee discount)',
      'Applicant identity proof'
    ],
    faqs: [
      { question: 'What is the government fee for startups?', answer: 'Government fee is ₹4,500 for individuals/startups/MSMEs, and ₹9,000 for large enterprises.' },
      { question: 'Can I register a slogan?', answer: 'Yes, slogans and taglines can be registered under trademark laws.' }
    ],
    seo: {
      title: 'Trademark Registration Online India – Brand Protection | MSMECenter',
      description: 'File trademark application online. Claim ™ symbol in 24 hours. Includes brand lookup search and class advice from CA lawyers.'
    },
    governmentFee: 4500,
    serviceCharge: 999,
    popular: false
  },
  {
    name: 'Website Development',
    slug: 'website-development',
    description: 'Stunning, custom, mobile-first websites designed to rank on Google and convert visitors.',
    price: 14999,
    category: 'digital',
    isActive: true,
    benefits: [
      'Fully mobile responsive design optimized for smartphones.',
      'SEO-friendly architecture with fast loading speeds.',
      'Modern, premium design using clean HTML5/React styles.',
      'Free SSL security certificate integration included.',
      'Admin CMS backend allowing easy updates without coding.'
    ],
    process: [
      { step: 1, title: 'Concept Planning', description: 'Decide sitemap, features, and visual style. Timeline: 3 days.' },
      { step: 2, title: 'UI/UX Mockups', description: 'Design landing pages and color schemes for your approval. Timeline: 5 days.' },
      { step: 3, title: 'Frontend Coding', description: 'Convert mockups into fast React or WordPress pages. Timeline: 7 days.' },
      { step: 4, title: 'Quality Assurance', description: 'Verify links, speeds, and cross-browser displays. Timeline: 3 days.' },
      { step: 5, title: 'Site Launch', description: 'Configure domain hosting and launch site. Timeline: 2 days.' }
    ],
    documents: [
      'High-resolution logo files',
      'Text copy about your services',
      'Domain details (we help register)',
      'Corporate email accounts wanted'
    ],
    faqs: [
      { question: 'Is domain and hosting included in the pricing?', answer: 'We assist in choosing the best hosts, but domain and hosting subscription costs are paid directly to host providers.' },
      { question: 'Can I edit the website pages later?', answer: 'Yes. We build an intuitive admin panel allowing you to upload images and edit text easily.' }
    ],
    seo: {
      title: 'Professional Website Development for Businesses | MSMECenter',
      description: 'Get custom business websites built by expert engineers. High conversion layouts, mobile optimization, and search-friendly structures.'
    },
    governmentFee: 0,
    serviceCharge: 14999,
    popular: true
  },
  {
    name: 'SEO Optimization',
    slug: 'seo-optimization',
    description: 'Improve search engine visibility, organic traffic, and keyword rankings for your business portal.',
    price: 9999,
    category: 'digital',
    isActive: true,
    benefits: [
      'Increase organic visitor traffic steadily over 90 days.',
      'Index business for competitive commercial transaction terms.',
      'Boost authority score via search engine catalog mapping.',
      'Technical check: resolve index locks and load delays.',
      'Detailed monthly audit report logs.'
    ],
    process: [
      { step: 1, title: 'Crawl Check', description: 'Perform technical crawler check. Timeline: 1 day.' },
      { step: 2, title: 'Keyword List', description: 'Group search tags and terms. Timeline: 2 days.' },
      { step: 3, title: 'Metadata Optimization', description: 'Configure tags, heading styles, and descriptions. Timeline: 3 days.' },
      { step: 4, title: 'Index Submission', description: 'Update sitemap and request index checks. Timeline: 1 day.' },
      { step: 5, title: 'Performance Monitoring', description: 'Deliver ranking reports. Timeline: 3 days.' }
    ],
    documents: [
      'Web panel login / CMS access',
      'GSC (Search Console) access keys',
      'Priority target keywords list'
    ],
    faqs: [
      { question: 'When do organic keyword improvements show up?', answer: 'Most sites record visible keyword shifts in 4 to 8 weeks.' },
      { question: 'Do you cover technical tags optimization?', answer: 'Yes, technical optimization (sitemaps, robots, schema tags) is fully covered.' }
    ],
    seo: {
      title: 'Organic SEO Optimization Services India | MSMECenter',
      description: 'Improve your Google search rankings. Technical audit, meta optimizations, and high-value keyword indexing designed for MSMEs.'
    },
    governmentFee: 0,
    serviceCharge: 9999,
    popular: false
  },
  {
    name: 'Google Ads Management',
    slug: 'google-ads-management',
    description: 'Target high-intent search queries and run optimized Google Ads campaigns to drive sales.',
    price: 14999,
    category: 'digital',
    isActive: true,
    benefits: [
      'Immediate lead generation once campaigns launch.',
      'Expert setup: match group bids to avoid high cost-per-click.',
      'Conversion triggers: configure analytics and goal logging.',
      'A/B testing on ad copies and visual designs.',
      'Exclude negative keywords to save ad budget waste.'
    ],
    process: [
      { step: 1, title: 'Campaign Goal', description: 'Establish daily budget limits and targets. Timeline: 1 day.' },
      { step: 2, title: 'Keyword Groups', description: 'Structure ad groups and bids. Timeline: 2 days.' },
      { step: 3, title: 'Setup Conversions', description: 'Link conversion tracking code. Timeline: 1 day.' },
      { step: 4, title: 'Write Ad Copy', description: 'Prepare ad headlines and descriptions. Timeline: 2 days.' },
      { step: 5, title: 'Launch Campaigns', description: 'Activate and optimize daily parameters. Timeline: Ongoing.' }
    ],
    documents: [
      'Google Ads account access keys',
      'Target landing page URLs',
      'Allocated ad spend budget'
    ],
    faqs: [
      { question: 'Is ad budget covered in your fee?', answer: 'No, ad spend is paid directly to Google. Our fee is for management.' },
      { question: 'How quickly do leads start appearing?', answer: 'Once Google verifies ads (typically 24 hours), traffic starts immediately.' }
    ],
    seo: {
      title: 'Google Ads & PPC Management Services | MSMECenter',
      description: 'Maximize your advertising ROI. Professional Google Ads setup, keyword optimization, and remarketing plans designed for MSMEs.'
    },
    governmentFee: 0,
    serviceCharge: 14999,
    popular: false
  },
  {
    name: 'Digital Marketing Package',
    slug: 'digital-marketing-package',
    description: 'Grow your business online. Get leads and sales via targeted Google and Meta ads and SEO.',
    price: 19999,
    category: 'marketing',
    isActive: true,
    benefits: [
      'Immediate visibility: Start receiving customer leads in days.',
      'Comprehensive coverage: Handles Facebook, Instagram, Google, and LinkedIn.',
      'Conversion-optimized copy and creative designs.',
      'Transparent tracking: Full lead and conversion dashboard integration.',
      'Weekly optimization to maximize advertising ROI.'
    ],
    process: [
      { step: 1, title: 'Business Audit', description: 'Audit your current presence and competitors. Timeline: 2 days.' },
      { step: 2, title: 'Ad Strategy', description: 'Design funnel flows and draft target audience. Timeline: 3 days.' },
      { step: 3, title: 'Asset Development', description: 'Create banner graphics, copywriting, and landing pages. Timeline: 5 days.' },
      { step: 4, title: 'Campaign Launch', description: 'Launch search and social media ad groups. Timeline: 1 day.' },
      { step: 5, title: 'Optimization & Report', description: 'Review results and adjust keywords and budget. Timeline: Ongoing.' }
    ],
    documents: [
      'Business logo & images',
      'Access to ad accounts (we set up if missing)',
      'List of target keywords / client profiles',
      'Monthly ad budget allocation'
    ],
    faqs: [
      { question: 'What is the recommended ad budget?', answer: 'We suggest starting with a minimum of ₹10,000 per month for ad platforms.' },
      { question: 'Do you guarantee sales?', answer: 'We guarantee highly targeted traffic and leads. Final conversion depends on product pricing and sales conversion.' }
    ],
    seo: {
      title: 'Digital Marketing Package for MSMEs – Growth Plans | MSMECenter',
      description: 'Boost your business leads. Expert Facebook/Meta ads, Google PPC campaigns, and organic SEO growth plans built for small businesses.'
    },
    governmentFee: 0,
    serviceCharge: 19999,
    popular: true
  },
  {
    name: 'Social Media Management',
    slug: 'social-media-management',
    description: 'Build organic presence on Instagram, LinkedIn, and Facebook with custom visual graphics.',
    price: 9999,
    category: 'marketing',
    isActive: true,
    benefits: [
      'Maintain an active, engaging social calendar automatically.',
      'Custom visual graphics reflecting premium brand standards.',
      'Engaging post descriptions containing target hashtags.',
      'Increase follower counts and build active customer networks.',
      'Monthly profile stats performance reviews.'
    ],
    process: [
      { step: 1, title: 'Design Template', description: 'Establish visual guidelines, typography, and brand rules. Timeline: 3 days.' },
      { step: 2, title: 'Content Outline', description: 'Plan upcoming posts and calendar schedules. Timeline: 2 days.' },
      { step: 3, title: 'Graphic Layouts', description: 'Design custom banners, posts, and infographics. Timeline: 5 days.' },
      { step: 4, title: 'Schedule Posts', description: 'Publish content during high engagement hours. Timeline: 1 day.' },
      { step: 5, title: 'Interaction Review', description: 'Verify comment replies and report growth parameters. Timeline: Ongoing.' }
    ],
    documents: [
      'Visual brand assets / Logo vector files',
      'Platform login credentials / Page access',
      'Target client profile details'
    ],
    faqs: [
      { question: 'How many posts are included in the package?', answer: 'Our standard package includes 12 custom posts and 8 stories scheduled monthly.' },
      { question: 'Will you manage comments and direct messages?', answer: 'We monitor comments; direct customer inquiry messages are forwarded directly to your sales team.' }
    ],
    seo: {
      title: 'Social Media Management Services for Brands | MSMECenter',
      description: 'Grow your business followers organically. Premium graphic layouts, Instagram grids, and LinkedIn posting packages designed for brands.'
    },
    governmentFee: 0,
    serviceCharge: 9999,
    popular: false
  },
  {
    name: 'Individual Credit Score Repair',
    slug: 'individual-credit-score-repair',
    description: 'Improve your personal CIBIL/credit score with expert dispute resolution. Boost by 50–100 points in 90 days.',
    price: 999,
    category: 'credit-repair',
    isActive: true,
    benefits: [
      'Expert CIBIL report analysis: review history for hidden issues.',
      'Negotiate with creditors to dispute errors and duplicate postings.',
      'Custom dispute letters submitted to all credit bureaus.',
      'Improve personal credit profile and secure future personal loans.',
      'Action plan to keep score above 750.'
    ],
    process: [
      { step: 1, title: 'Analyze Report', description: 'Analyze your CIBIL profile. Timeline: 1 day.' },
      { step: 2, title: 'Flag Errors', description: 'Identify duplicated details and late fee errors. Timeline: 1 day.' },
      { step: 3, title: 'File Disputes', description: 'Draft and submit dispute claims to bureaus. Timeline: 2 days.' },
      { step: 4, title: 'Bureau Review', description: 'Bureaus check facts and update details. Timeline: 30-45 days.' },
      { step: 5, title: 'Update Score', description: 'Score reflects updates. Timeline: 7 days.' }
    ],
    documents: [
      'PAN card',
      'Aadhaar card',
      'Latest credit bureau report files'
    ],
    faqs: [
      { question: 'Is credit score repair legal?', answer: 'Yes, disputing credit errors is fully legal under RBI guidelines.' },
      { question: 'How much can my score improve?', answer: 'Most clients record improvements of 50 to 100 points.' }
    ],
    seo: {
      title: 'Individual Credit Score & CIBIL Repair | MSMECenter',
      description: 'Improve your CIBIL score. Remove errors, dispute incorrect payment history details, and increase loan eligibility.'
    },
    governmentFee: 0,
    serviceCharge: 999,
    popular: false
  },
  {
    name: 'Commercial Credit Score Repair',
    slug: 'commercial-credit-score-repair',
    description: 'Enhance your business credit rating to unlock better loan terms, higher limits, and partner trust.',
    price: 1999,
    category: 'credit-repair',
    isActive: true,
    benefits: [
      'Build a strong commercial credit profile for funding.',
      'Resolve incorrect business defaults on bureau files.',
      'Accelerate banking line approvals with lower interest.',
      'Negotiate write-offs and duplicate defaults directly.',
      'Verify positive commercial payment indicators.'
    ],
    process: [
      { step: 1, title: 'Business Profile Audit', description: 'Audit commercial credit files. Timeline: 2 days.' },
      { step: 2, title: 'Identify Inaccuracies', description: 'Identify wrong loan amounts and false defaults. Timeline: 1 day.' },
      { step: 3, title: 'Submit Claims', description: 'Submit claims to commercial credit bureaus. Timeline: 3 days.' },
      { step: 4, title: 'Bank Liaison', description: 'Coordinate with banks to update closure statements. Timeline: 15 days.' },
      { step: 5, title: 'Refresh Score', description: 'Generate fresh commercial credit score. Timeline: 10 days.' }
    ],
    documents: [
      'Business PAN card',
      'GSTIN Certificate',
      'Bank NOC statements / closure letters'
    ],
    faqs: [
      { question: 'What commercial credit scores are used in India?', answer: 'CRIF Commercial Score and Experian Business Score are widely used.' },
      { question: 'How long does business credit repair take?', answer: 'Usually 45 to 60 days.' }
    ],
    seo: {
      title: 'Commercial Credit Rating Repair Services | MSMECenter',
      description: 'Improve your business credit score. Fix errors on CRIF and Experian, resolve outstanding disputes, and secure bank approvals.'
    },
    governmentFee: 0,
    serviceCharge: 1999,
    popular: false
  },
  {
    name: 'Business Loans',
    slug: 'business-loans',
    description: 'Unsecured business funding and CGTMSE options up to ₹5 Crore with competitive bank interest rates.',
    price: 0,
    category: 'loans',
    isActive: true,
    benefits: [
      'Secure collateral-free loans up to ₹2 Crore under the CGTMSE cover.',
      'Fast sanction times matching your urgent working capital needs.',
      'Lowest interest rates matching priority MSME sector parameters.',
      'Transparent evaluation: Zero upfront booking fee on loans.',
      'Direct application routing to 15+ partner banks and NBFCs.'
    ],
    process: [
      { step: 1, title: 'Upload Profile', description: 'Share business vintage, turnover, and credit score. Timeline: 15 mins.' },
      { step: 2, title: 'Lenders Matching', description: 'Our algorithms match parameters to find active bank programs. Timeline: 2 hours.' },
      { step: 3, title: 'Document Audit', description: 'Submit ITR, audited balances, and bank logs. Timeline: 1 day.' },
      { step: 4, title: 'Bank Underwriting', description: 'Partner bank reviews project viability and sanctions amount. Timeline: 3-5 days.' },
      { step: 5, title: 'Disbursal', description: 'Sanctioned funds transferred directly to corporate account. Timeline: 2 days.' }
    ],
    documents: [
      'Audited financials (last 2 years)',
      'Bank statement logs (last 12 months)',
      'GST returns (last 12 months)',
      'Promoter identity proofs'
    ],
    faqs: [
      { question: 'What is the CGTMSE scheme?', answer: 'A government guarantee cover enabling banks to sanction collateral-free loans up to ₹5 Crore to micro and small businesses.' },
      { question: 'What credit score is needed?', answer: 'A credit score above 700 is preferred for secured business finance.' }
    ],
    seo: {
      title: 'Government Subsidized Business Loans India | MSMECenter',
      description: 'Apply for unsecured business funding and CGTMSE collateral-free loans. Minimal documentation and low interest rates.'
    },
    governmentFee: 0,
    serviceCharge: 0,
    popular: true
  },
  {
    name: 'Working Capital Loan',
    slug: 'working-capital-loan',
    description: 'Finance your day-to-day business operations and manage cash flow gaps seamlessly.',
    price: 0,
    category: 'loans',
    isActive: true,
    benefits: [
      'Maintain healthy cash flow for daily operations.',
      'Flexible overdraft / cash credit limits.',
      'Pay interest only on the utilized credit amount.',
      'Acquire quick approval with minimal collateral.',
      'Customized repayment options tailored to business seasonal demands.'
    ],
    process: [
      { step: 1, title: 'Cycle Evaluation', description: 'Evaluate working capital gap parameters. Timeline: 1 day.' },
      { step: 2, title: 'Bank Match', description: 'Locate banking programs. Timeline: 2 hours.' },
      { step: 3, title: 'Credit Analysis', description: 'Analyze debtors and transaction logs. Timeline: 2 days.' },
      { step: 4, title: 'Limit Sanction', description: 'Receive overdraft or cash credit sanction letter. Timeline: 3 days.' },
      { step: 5, title: 'Account Activation', description: 'Disburse limit for business withdrawals. Timeline: 2 days.' }
    ],
    documents: [
      'GST returns (last 12 months)',
      'Debtors and creditors list logs',
      'Audited P&L sheets (last 2 years)',
      'Bank accounts log (last 12 months)'
    ],
    faqs: [
      { question: 'How is working capital interest calculated?', answer: 'Interest is charged only on the cash limit drawn, not the entire setup limit.' },
      { question: 'Can startups apply?', answer: 'Startups with stable traction or purchase orders can apply for working capital limits.' }
    ],
    seo: {
      title: 'Working Capital Loans & Overdraft Limits | MSMECenter',
      description: 'Finance your business cash flow cycles. Apply for cash credit and overdraft limits from leading banks with expert CA support.'
    },
    governmentFee: 0,
    serviceCharge: 0,
    popular: false
  },
  {
    name: 'Equipment Finance',
    slug: 'equipment-finance',
    description: 'Specialized loans to purchase machinery, vehicles, and equipment for manufacturing or services.',
    price: 0,
    category: 'loans',
    isActive: true,
    benefits: [
      'Fund up to 90% of equipment or machinery costs.',
      'Asset itself serves as primary security (no extra collateral).',
      'Get tax benefits on interest payments and depreciation.',
      'Flexible loan tenures up to 7 years.',
      'Custom EMIs matching seasonal output capacities.'
    ],
    process: [
      { step: 1, title: 'Collect Invoice', description: 'Request proforma invoice from machinery vendor. Timeline: 1 hour.' },
      { step: 2, title: 'File Application', description: 'Submit invoice along with balance sheets. Timeline: 1 day.' },
      { step: 3, title: 'Machine Valuation', description: 'Lenders verify machine details and specs. Timeline: 2 days.' },
      { step: 4, title: 'Sanction and Sign', description: 'Sanction loan with machine hypothecated. Timeline: 3 days.' },
      { step: 5, title: 'Direct Disbursal', description: 'Lender pays vendor directly to deliver machinery. Timeline: 2 days.' }
    ],
    documents: [
      'Proforma invoice from equipment supplier',
      'Business incorporation proofs',
      'Financial reports (last 2 years)',
      'Bank transaction logs (last 6 months)'
    ],
    faqs: [
      { question: 'Do I need extra collateral for equipment finance?', answer: 'No, the machinery being financed serves as the collateral.' },
      { question: 'What is the standard interest rate?', answer: 'It starts from 9% to 14% p.a. depending on credit rating.' }
    ],
    seo: {
      title: 'Machinery & Equipment Loans for MSMEs | MSMECenter',
      description: 'Secure funding to purchase business machinery and commercial equipment. High LTV financing with CA documentation support.'
    },
    governmentFee: 0,
    serviceCharge: 0,
    popular: false
  },
  {
    name: 'CIBIL Report Correction & Audit',
    slug: 'cibil-report-correction-and-audit',
    description: 'Audit your commercial/personal CIBIL report and resolve disputes, incorrect entries, and delays to restore your loan eligibility.',
    price: 4999,
    category: 'credit-repair',
    isActive: true,
    benefits: [
      'Increases credit score by rectifying wrong delayed payment flags.',
      'Clears wrong write-off records and settled accounts classifications.',
      'Disputes incorrect loan accounts falsely assigned to your PAN.',
      'Improves creditworthiness and chances of premium loan approvals.',
      'Dedicated compliance manager representing you before bureaus.'
    ],
    process: [
      { step: 1, title: 'Report Pull & Analysis', description: 'Acquire your official CRIF, Equifax, and CIBIL reports. Timeline: 1 day.' },
      { step: 2, title: 'Identify Inaccuracies', description: 'Highlight disputed active items, settlement dates, and write-offs. Timeline: 1 day.' },
      { step: 3, title: 'Lodge Bureau Disputes', description: 'Raise official online disputes directly with credit bureaus. Timeline: 2 days.' },
      { step: 4, title: 'Bank Liaison Verification', description: 'Follow up with lending banks for correction approval. Timeline: 15-20 days.' },
      { step: 5, title: 'Updated Report Delivery', description: 'Receive updated clean credit report with restored score. Timeline: 5 days.' }
    ],
    documents: [
      'PAN Card copy',
      'Aadhaar Card copy',
      'Recent CIBIL report (if available)',
      'No Objection Certificate (NOC) / Settlement letter from bank'
    ],
    faqs: [
      { question: 'How long does CIBIL dispute resolution take?', answer: 'Typically, bureaus require 30 to 45 days to verify and update dispute claims with banks.' },
      { question: 'Do you guarantee an increase in score?', answer: 'We guarantee correction of all genuine report errors, which naturally boosts the credit score.' }
    ],
    seo: {
      title: 'Commercial CIBIL Rectification & Dispute Filing Online | MSMECenter',
      description: 'Rectify incorrect entries, write-offs, and delayed flags in your business CIBIL report. Professional credit score audit service for MSMEs.'
    },
    governmentFee: 0,
    serviceCharge: 4999,
    popular: true
  },
  {
    name: 'Defaulter Credit Rectification',
    slug: 'defaulter-credit-rectification',
    description: 'Resolve settlement record disputes, clear written-off accounts, and restore credit rating with major bureaus.',
    price: 3499,
    category: 'credit-repair',
    isActive: true,
    benefits: [
      'Removes persistent default flags from active loan profiles.',
      'Assists in filing documentation to show closed status after loan settlement.',
      'Disputes records that remain un-updated after full payment.',
      'Direct coordination with credit institutions.'
    ],
    process: [
      { step: 1, title: 'Audit Account Status', description: 'Audit loan details of disputed written-off accounts. Timeline: 1 day.' },
      { step: 2, title: 'Draft Rectification Request', description: 'Prepare legal dispute letter and proof bundle. Timeline: 2 days.' },
      { step: 3, title: 'Bank Communication', description: 'Escalate claims to bank compliance cells. Timeline: 5-7 days.' },
      { step: 4, title: 'Record Update Verification', description: 'Ensure bank sends updated status to credit bureaus. Timeline: 10 days.' }
    ],
    documents: [
      'PAN & Aadhaar Card',
      'Disputed loan account statements',
      'Full payment receipts or bank NOC'
    ],
    faqs: [
      { question: 'What is a settled account?', answer: 'A settled account means the lender accepted a lower amount than due, which hurts credit score. We help present justification and clear associated flags.' }
    ],
    seo: {
      title: 'Defaulter & Delay Rectification Audit - Credit Repair | MSMECenter',
      description: 'Resolve disputes regarding settled accounts, clear default flags, and fix credit bureau records online.'
    },
    governmentFee: 0,
    serviceCharge: 3499,
    popular: false
  },
  {
    name: 'CA-certified CMA Report Drafting',
    slug: 'ca-certified-cma-report-drafting',
    description: 'Get a professionally structured Credit Monitoring Arrangement (CMA) report for bank loan appraisal.',
    price: 4999,
    category: 'loans',
    isActive: true,
    benefits: [
      'Formulated as per RBI and commercial bank requirements.',
      'Accurate projections of balance sheets, ratios, and working capital needs.',
      'Vetted by senior chartered accountants.',
      'Maximizes business loan approval chances.'
    ],
    process: [
      { step: 1, title: 'Data Gathering', description: 'Gather last 3 years audit financials and projected growth targets. Timeline: 1 day.' },
      { step: 2, title: 'Financial Modeling', description: 'Model cash flows, balance sheets, and key ratios. Timeline: 2 days.' },
      { step: 3, title: 'CA Vetting', description: 'Review report alignment with banking norms by CAs. Timeline: 1 day.' },
      { step: 4, title: 'Final Report Delivery', description: 'Receive PDF and Excel format CMA report for submission. Timeline: 1 day.' }
    ],
    documents: [
      '3 Years audited financial statements',
      'Sanction letters of current loans',
      'Sales and purchase projections'
    ],
    faqs: [
      { question: 'Why do banks require a CMA report?', answer: 'Banks use CMA reports to evaluate the financial feasibility, repayment capability, and working capital requirement of the business.' }
    ],
    seo: {
      title: 'CMA Report Drafting Online by Chartered Accountants | MSMECenter',
      description: 'Draft CA-certified CMA reports for business loans and working capital overdrafts online in 3-5 working days.'
    },
    governmentFee: 0,
    serviceCharge: 4999,
    popular: true
  },
  {
    name: 'Section 8 NGO Company Registration',
    slug: 'section-8-ngo-company-registration',
    description: 'Incorporate a Section 8 NGO company online with 12A & 80G tax exemptions.',
    price: 13999,
    category: 'registration',
    isActive: true,
    benefits: [
      'Enables legal non-profit status with corporate advantages.',
      'Qualifies for 12A & 80G certificates for tax exemption on donations.',
      'Zero share capital requirement.',
      'Increases credibility for receiving corporate CSR funds.'
    ],
    process: [
      { step: 1, title: 'Digital Signatures', description: 'Secure DSC for directors and promoters. Timeline: 1 day.' },
      { step: 2, title: 'Name Approval & License', description: 'File name reservation and apply for Section 8 license (Form RD-1). Timeline: 4-5 days.' },
      { step: 3, title: 'SPICe+ Incorporation', description: 'File integrated company registration form with MCA. Timeline: 3 days.' },
      { step: 4, title: 'Exemption Application', description: 'Apply for 12A/80G status with Income Tax Department. Timeline: 10 days.' }
    ],
    documents: [
      'PAN & Aadhaar of all promoters (min. 2)',
      'Office address utility bill',
      'No Objection Certificate (NOC) from owner',
      'Main objectives of the non-profit'
    ],
    faqs: [
      { question: 'What is a Section 8 Company?', answer: 'It is a company registered under Section 8 of Companies Act, 2013, established for promoting charity, science, art, etc., without distribution of dividends to shareholders.' }
    ],
    seo: {
      title: 'Section 8 Company Registration Online India | MSMECenter',
      description: 'Register a Section 8 NGO company online with tax exemptions. Comprehensive incorporation service by CAs.'
    },
    governmentFee: 4000,
    serviceCharge: 9999,
    popular: false
  },
  {
    name: 'FSSAI Food License',
    slug: 'fssai-food-license',
    description: 'Obtain FSSAI food license or registration for your food business — mandatory for manufacturers, restaurants, cloud kitchens, and traders.',
    price: 1999,
    category: 'registration',
    isActive: true,
    benefits: [
      'Legally sell, manufacture, store, or distribute food products.',
      'Mandatory compliance — avoids ₹5 lakh penalty for operating without license.',
      'Builds consumer trust with the FSSAI logo on packaging.',
      'Required for Swiggy, Zomato, and Amazon grocery onboarding.',
      'Enables export of food products with FSSAI clearance.'
    ],
    process: [
      { step: 1, title: 'Determine License Type', description: 'Identify Basic/State/Central license based on turnover and operations. Timeline: 1 day.' },
      { step: 2, title: 'Document Preparation', description: 'Compile layout plan, water test report, and food safety plan. Timeline: 2 days.' },
      { step: 3, title: 'Online Application', description: 'File application on FSSAI FoSCoS portal with fees. Timeline: 1 day.' },
      { step: 4, title: 'Inspection & Approval', description: 'Coordinate with FSSAI inspector visit (if applicable). Timeline: 7-15 days.' },
      { step: 5, title: 'License Issued', description: 'Receive 14-digit FSSAI license number for display. Timeline: 3 days.' }
    ],
    documents: [
      'PAN Card of proprietor / company',
      'Aadhaar Card',
      'Proof of business premises',
      'Food safety management plan',
      'List of food products with brand name',
      'Water test report (for manufacturing)'
    ],
    faqs: [
      { question: 'Is FSSAI registration mandatory?', answer: 'Yes, every food business operator in India must have FSSAI registration or license under FSS Act 2006.' },
      { question: 'What is the difference between registration and license?', answer: 'Registration is for businesses with turnover under ₹12 lakhs. State license for ₹12L–₹20Cr, and Central license for above ₹20Cr or for importers/exporters.' }
    ],
    seo: {
      title: 'FSSAI Food License Registration Online India | MSMECenter',
      description: 'Apply for FSSAI food license online. Basic, State & Central FSSAI registration for restaurants, cloud kitchens, manufacturers & traders.'
    },
    governmentFee: 100,
    serviceCharge: 1899,
    popular: true
  },
  {
    name: 'Import Export Code (IEC)',
    slug: 'import-export-code-iec',
    description: 'Register for IEC — the mandatory 10-digit code required for all import and export transactions in India.',
    price: 1999,
    category: 'registration',
    isActive: true,
    benefits: [
      'Mandatory for customs clearance on imports and exports.',
      'Lifetime validity — no renewal required.',
      'Enables access to DGFT export incentive schemes like RoDTEP and MEIS.',
      'Required for opening foreign currency bank accounts.',
      'Online process with zero physical visits.'
    ],
    process: [
      { step: 1, title: 'PAN Verification', description: 'Verify PAN details with DGFT system. Timeline: 1 day.' },
      { step: 2, title: 'Application Filing', description: 'Submit IEC application on DGFT portal with digital signature. Timeline: 1 day.' },
      { step: 3, title: 'Fee Payment', description: 'Pay government processing fee online. Timeline: Same day.' },
      { step: 4, title: 'IEC Certificate', description: 'Receive IEC certificate via email from DGFT. Timeline: 2-3 days.' }
    ],
    documents: [
      'PAN Card of firm/company',
      'Aadhaar Card of proprietor/director',
      'Cancel cheque or bank certificate',
      'Certificate of Incorporation (for companies)',
      'Address proof of business premises'
    ],
    faqs: [
      { question: 'Is IEC required for service exports?', answer: 'IEC is mandatory for goods export. For service exports, it is needed to avail export incentives under SEIS.' },
      { question: 'How long is IEC valid?', answer: 'IEC has lifetime validity. However, annual updates on the DGFT portal are required.' }
    ],
    seo: {
      title: 'Import Export Code (IEC) Registration Online | MSMECenter',
      description: 'Apply for IEC registration online. Get your 10-digit Import Export Code from DGFT in 2-3 working days.'
    },
    governmentFee: 500,
    serviceCharge: 1499,
    popular: false
  },
  {
    name: 'One Person Company (OPC) Registration',
    slug: 'one-person-company-opc-registration',
    description: 'Incorporate a One Person Company — enjoy limited liability and corporate status as a solo entrepreneur.',
    price: 7999,
    category: 'registration',
    isActive: true,
    benefits: [
      'Single shareholder enjoys 100% ownership with limited liability.',
      'Separate legal entity like Private Limited but with one member.',
      'No minimum capital requirement under Companies Act 2013.',
      'Lower compliance burden than Pvt Ltd — no mandatory AGM required.',
      'Can be converted to Pvt Ltd when business scales.'
    ],
    process: [
      { step: 1, title: 'DSC & DIN', description: 'Obtain Digital Signature Certificate and Director Identification Number. Timeline: 1 day.' },
      { step: 2, title: 'Name Reservation', description: 'Reserve unique company name through MCA RUN service. Timeline: 2 days.' },
      { step: 3, title: 'Nominee Declaration', description: 'File Form INC-3 (nominee consent) as OPC requires a nominee member. Timeline: 1 day.' },
      { step: 4, title: 'SPICe+ Filing', description: 'Submit incorporation via integrated SPICe+ form. Timeline: 3 days.' },
      { step: 5, title: 'Certificate of Incorporation', description: 'Receive CoI, PAN, TAN, and GSTIN. Timeline: 2 days.' }
    ],
    documents: [
      'PAN Card of the sole member and nominee',
      'Aadhaar Card of member and nominee',
      'Address proof of registered office',
      'Passport-size photographs',
      'Nominee consent letter (Form INC-3)'
    ],
    faqs: [
      { question: 'Who can register an OPC?', answer: 'Only an Indian citizen who is also a resident of India (stayed 182+ days in previous year) can incorporate an OPC.' },
      { question: 'What is the nominee requirement?', answer: 'OPC must appoint a nominee who becomes the member in case the original member is incapacitated or dies.' }
    ],
    seo: {
      title: 'One Person Company (OPC) Registration Online India | MSMECenter',
      description: 'Register OPC online with expert CA guidance. Single-owner company with limited liability, PAN, TAN & GST included.'
    },
    governmentFee: 3000,
    serviceCharge: 4999,
    popular: false
  },
  {
    name: 'Partnership Firm Registration',
    slug: 'partnership-firm-registration',
    description: 'Register your partnership firm under the Indian Partnership Act, 1932, with a legally binding deed drafted by our experts.',
    price: 4999,
    category: 'registration',
    isActive: true,
    benefits: [
      'Simple formation process with minimal compliance requirements.',
      'Professionally drafted partnership deed covering profit-sharing, duties, and dissolution clauses.',
      'Registered firms can file legal suits against third parties and partners.',
      'No minimum capital requirement.',
      'Can be converted to LLP or Pvt Ltd later.'
    ],
    process: [
      { step: 1, title: 'Deed Drafting', description: 'Draft comprehensive partnership agreement covering roles, profit sharing, and exit clauses. Timeline: 2 days.' },
      { step: 2, title: 'Stamp Duty Payment', description: 'Purchase stamp paper as per state-specific rates. Timeline: 1 day.' },
      { step: 3, title: 'Deed Execution', description: 'Partners sign the deed on stamp paper. Timeline: 1 day.' },
      { step: 4, title: 'Registrar Filing', description: 'File Form-1 with the Registrar of Firms. Timeline: 3-5 days.' },
      { step: 5, title: 'Registration Certificate', description: 'Receive partnership registration certificate. Timeline: 7 days.' }
    ],
    documents: [
      'PAN Card of all partners',
      'Aadhaar / Voter ID of all partners',
      'Address proof of firm (rent agreement / electricity bill)',
      'Passport-size photographs of partners'
    ],
    faqs: [
      { question: 'Is partnership registration mandatory?', answer: 'Registration is optional but highly recommended. Unregistered firms cannot sue partners or third parties in court.' },
      { question: 'How many partners are needed?', answer: 'Minimum 2, maximum 50 partners are allowed under the Indian Partnership Act.' }
    ],
    seo: {
      title: 'Partnership Firm Registration Online – Deed Drafting | MSMECenter',
      description: 'Register your partnership firm online with a professionally drafted deed. Fast, affordable, and legally compliant.'
    },
    governmentFee: 1000,
    serviceCharge: 3999,
    popular: false
  },
  {
    name: 'ISO Certification Assistance',
    slug: 'iso-certification-assistance',
    description: 'Get ISO 9001, ISO 14001, ISO 22000, or ISO 27001 certification with end-to-end documentation and audit coordination.',
    price: 8999,
    category: 'compliance',
    isActive: true,
    benefits: [
      'Enhances brand credibility and customer confidence.',
      'Mandatory for government tenders and large corporate vendor empanelment.',
      'Improves internal process efficiency with documented SOPs.',
      'Internationally recognized quality standard.',
      'Valid for 3 years with annual surveillance audits.'
    ],
    process: [
      { step: 1, title: 'Gap Analysis', description: 'Assess current processes against ISO standard requirements. Timeline: 2-3 days.' },
      { step: 2, title: 'Documentation Preparation', description: 'Draft quality manual, SOPs, and required procedures. Timeline: 5-7 days.' },
      { step: 3, title: 'Internal Audit', description: 'Conduct mock internal audit to identify non-conformities. Timeline: 2 days.' },
      { step: 4, title: 'Certification Body Audit', description: 'Coordinate Stage 1 & Stage 2 audits with accredited body. Timeline: 5-10 days.' },
      { step: 5, title: 'Certificate Issuance', description: 'Receive ISO certification post successful audit clearance. Timeline: 5 days.' }
    ],
    documents: [
      'Company registration certificate',
      'GST registration (if applicable)',
      'Organization chart',
      'Existing process documentation (if any)',
      'List of products/services offered'
    ],
    faqs: [
      { question: 'Which ISO standard do I need?', answer: 'ISO 9001 (Quality), ISO 14001 (Environment), ISO 22000 (Food Safety), ISO 27001 (Information Security). We help identify the right one for your industry.' },
      { question: 'How long does ISO certification take?', answer: 'Typically 3-6 weeks from gap analysis to certificate issuance, depending on company readiness.' }
    ],
    seo: {
      title: 'ISO Certification Service Online – 9001, 14001, 22000, 27001 | MSMECenter',
      description: 'Get ISO certified with expert assistance. End-to-end documentation, internal audit, and certification body coordination for MSMEs.'
    },
    governmentFee: 0,
    serviceCharge: 8999,
    popular: true
  },
  {
    name: 'Patent Registration & Filing',
    slug: 'patent-registration-and-filing',
    description: 'File and register a patent for your invention with the Indian Patent Office. 20-year exclusive protection for your innovation.',
    price: 19849,
    category: 'legal',
    isActive: true,
    benefits: [
      '20-year exclusive rights to manufacture, sell, or license your invention.',
      'Prevents competitors from copying your technology or design.',
      'Increases company valuation and attracts investors.',
      'Qualifies for MSME startup patent fee rebates (up to 80% discount).',
      'Can be monetized through licensing agreements.'
    ],
    process: [
      { step: 1, title: 'Prior Art Search', description: 'Search existing patents globally to verify novelty. Timeline: 3-5 days.' },
      { step: 2, title: 'Provisional Application', description: 'File provisional specification to secure priority date. Timeline: 2 days.' },
      { step: 3, title: 'Complete Specification', description: 'Draft and file complete patent specification within 12 months. Timeline: 5-7 days.' },
      { step: 4, title: 'Publication & Examination', description: 'Patent published in journal; request examination. Timeline: 1-6 months.' },
      { step: 5, title: 'Grant of Patent', description: 'Patent granted post examination and resolution of objections. Timeline: 12-36 months.' }
    ],
    documents: [
      'Detailed description of the invention',
      'Drawings/diagrams of the invention',
      'Inventor PAN & Aadhaar',
      'Priority document (if claiming foreign priority)',
      'Proof of MSME/startup status (for fee rebate)'
    ],
    faqs: [
      { question: 'How long does patent registration take?', answer: 'Filing is quick (1-2 weeks), but full grant typically takes 2-4 years. The provisional filing secures your priority date immediately.' },
      { question: 'What qualifies for a patent?', answer: 'The invention must be novel, non-obvious, and have industrial applicability. Software algorithms alone are not patentable in India.' }
    ],
    seo: {
      title: 'Patent Registration & Filing Online India – Protect Your Invention | MSMECenter',
      description: 'File a patent in India online. Prior art search, provisional & complete specification filing, with MSME startup fee rebates.'
    },
    governmentFee: 1600,
    serviceCharge: 18249,
    popular: false
  },
  {
    name: 'Copyright Registration',
    slug: 'copyright-registration',
    description: 'Register copyright for your literary works, music, software, artistic designs, or cinematograph films with the Copyright Office.',
    price: 2999,
    category: 'legal',
    isActive: true,
    benefits: [
      'Legal proof of ownership enforceable in court.',
      'Protection lasts lifetime of author + 60 years.',
      'Prevents unauthorized reproduction, distribution, or adaptation.',
      'Essential for software companies, content creators, and publishers.',
      'Enables licensing and royalty income.'
    ],
    process: [
      { step: 1, title: 'Work Classification', description: 'Classify your work (literary, artistic, musical, software, film). Timeline: 1 day.' },
      { step: 2, title: 'Application Drafting', description: 'Prepare Form XIV with full details and statement of particulars. Timeline: 2 days.' },
      { step: 3, title: 'Filing with Copyright Office', description: 'Submit online application and pay government fee. Timeline: 1 day.' },
      { step: 4, title: 'Mandatory Waiting Period', description: '30-day objection period after diary number is issued. Timeline: 30 days.' },
      { step: 5, title: 'Examination & Registration', description: 'Examiner reviews and issues registration certificate. Timeline: 2-6 months.' }
    ],
    documents: [
      'Copy of the work to be copyrighted',
      'Author PAN & Aadhaar',
      'NOC from publisher (if applicable)',
      'Power of Attorney (if filed through agent)',
      'Source code printout (for software copyright)'
    ],
    faqs: [
      { question: 'Is copyright registration mandatory?', answer: 'Copyright exists automatically upon creation, but registration provides legal evidence of ownership and is recommended for enforcement.' },
      { question: 'Can I copyright a mobile app?', answer: 'Yes, the source code of a mobile app qualifies as a literary work and can be copyrighted. The UI design can also be separately copyrighted as an artistic work.' }
    ],
    seo: {
      title: 'Copyright Registration Online India – Software, Music, Art | MSMECenter',
      description: 'Register copyright for software, books, music, designs & films. Lifetime protection with legal proof of ownership.'
    },
    governmentFee: 500,
    serviceCharge: 2499,
    popular: false
  },
  {
    name: 'MSME Subsidy & Grant Consulting',
    slug: 'msme-subsidy-grant-consulting',
    description: 'Expert guidance to identify, apply for, and secure government subsidies, grants, and incentive schemes for your MSME.',
    price: 7999,
    category: 'loans',
    isActive: true,
    benefits: [
      'Access 50+ central and state government MSME schemes.',
      'Professional project report preparation for subsidy applications.',
      'Assistance with CLCSS, PMEGP, CGTMSE, and state-specific incentives.',
      'Maximize subsidy amounts with correctly structured applications.',
      'End-to-end support from identification to disbursement.'
    ],
    process: [
      { step: 1, title: 'Business Assessment', description: 'Evaluate your business profile, sector, and eligibility for schemes. Timeline: 1-2 days.' },
      { step: 2, title: 'Scheme Mapping', description: 'Shortlist applicable central & state schemes with maximum benefit. Timeline: 2 days.' },
      { step: 3, title: 'Documentation Preparation', description: 'Prepare project reports, DPR, and required application documents. Timeline: 5-7 days.' },
      { step: 4, title: 'Application Submission', description: 'Submit applications through respective government portals. Timeline: 2-3 days.' },
      { step: 5, title: 'Follow-up & Disbursement', description: 'Track application status and coordinate with nodal agencies. Timeline: 30-90 days.' }
    ],
    documents: [
      'Udyam Registration Certificate',
      'GST Registration Certificate',
      'Company/Firm registration documents',
      'Last 3 years financial statements',
      'Project report / Business plan',
      'Bank statements (6 months)'
    ],
    faqs: [
      { question: 'What subsidies can I get?', answer: 'Depends on your sector, location, and business size. Common ones include CLCSS (15-25% capital subsidy), PMEGP (15-35% margin money), and various state industrial incentives.' },
      { question: 'Is there a success fee?', answer: 'Our base fee covers identification and application. A success fee may apply for high-value subsidies upon actual disbursement.' }
    ],
    seo: {
      title: 'MSME Subsidy & Grant Consulting – Government Schemes Expert | MSMECenter',
      description: 'Find and apply for MSME government subsidies, grants & incentives. Expert consulting for CLCSS, PMEGP, CGTMSE & state schemes.'
    },
    governmentFee: 0,
    serviceCharge: 7999,
    popular: true
  },
  {
    name: 'Annual ROC Filing & Compliance',
    slug: 'annual-roc-filing-and-compliance',
    description: 'Complete annual ROC compliance — file AOC-4, MGT-7/7A, and conduct board meetings as required under Companies Act.',
    price: 5599,
    category: 'compliance',
    isActive: true,
    benefits: [
      'Avoid heavy penalties for late ROC filing (up to ₹1 lakh/year).',
      'Maintain active company status — prevents strike-off by ROC.',
      'Professionally prepared financial statements in MCA format.',
      'Compliance calendar management throughout the year.',
      'Board meeting minutes and resolutions drafted by CS experts.'
    ],
    process: [
      { step: 1, title: 'Financial Statement Preparation', description: 'Prepare balance sheet and P&L in MCA-compliant format. Timeline: 3-5 days.' },
      { step: 2, title: 'Board Meeting & AGM', description: 'Conduct and minute board meetings and Annual General Meeting. Timeline: 2 days.' },
      { step: 3, title: 'AOC-4 Filing', description: 'File financial statements with MCA. Timeline: 1 day.' },
      { step: 4, title: 'MGT-7/7A Filing', description: 'File annual return with MCA. Timeline: 1 day.' },
      { step: 5, title: 'Compliance Report', description: 'Receive annual compliance completion report for records. Timeline: 1 day.' }
    ],
    documents: [
      'Previous year financial statements',
      'Bank statements for the financial year',
      'Details of any changes in directors/shareholders',
      'Minutes of previous board meetings'
    ],
    faqs: [
      { question: 'What is the deadline for ROC filing?', answer: 'AOC-4 must be filed within 30 days of AGM, and MGT-7 within 60 days. AGM must be held within 6 months of financial year end.' },
      { question: 'What happens if I miss ROC filing?', answer: 'Late filing attracts additional fees of ₹100/day. Persistent non-compliance can lead to company strike-off and director disqualification.' }
    ],
    seo: {
      title: 'Annual ROC Filing & Compliance Service Online | MSMECenter',
      description: 'File AOC-4, MGT-7 annual returns with MCA. Complete ROC compliance with board meeting minutes and AGM management.'
    },
    governmentFee: 600,
    serviceCharge: 4999,
    popular: false
  },
  {
    name: 'TDS Return Filing',
    slug: 'tds-return-filing',
    description: 'File quarterly TDS returns (Form 24Q, 26Q, 27Q) accurately and on time. Avoid interest and penalty on late deductions.',
    price: 2499,
    category: 'compliance',
    isActive: true,
    benefits: [
      'Avoid 1.5% monthly interest on late TDS deposit.',
      'Prevent penalty of ₹200/day for late TDS return filing.',
      'Accurate Form 16/16A generation for employees and vendors.',
      'Ensures correct TDS certificates for all deductees.',
      'Quarterly filing with year-round expert support.'
    ],
    process: [
      { step: 1, title: 'Data Collection', description: 'Collect salary registers, vendor invoices, and payment details. Timeline: 1 day.' },
      { step: 2, title: 'TDS Computation', description: 'Calculate TDS liability with correct section-wise rates. Timeline: 1 day.' },
      { step: 3, title: 'Challan Verification', description: 'Verify TDS challan deposits match computed liabilities. Timeline: 1 day.' },
      { step: 4, title: 'Return Filing', description: 'File quarterly return on TRACES portal via RPU utility. Timeline: 1 day.' },
      { step: 5, title: 'Certificate Generation', description: 'Download and distribute Form 16/16A certificates. Timeline: 1 day.' }
    ],
    documents: [
      'TAN registration details',
      'Salary registers / employee details',
      'Vendor PAN numbers and invoices',
      'TDS challan receipts',
      'Previous quarter return acknowledgements'
    ],
    faqs: [
      { question: 'How often is TDS return filed?', answer: 'TDS returns are filed quarterly — by July 31, October 31, January 31, and May 31 for each respective quarter.' },
      { question: 'Is TDS applicable for small businesses?', answer: 'Yes, if your turnover exceeds ₹1 crore (business) or ₹50 lakhs (professionals), TDS deduction is mandatory on specified payments.' }
    ],
    seo: {
      title: 'TDS Return Filing Service Online – Quarterly 24Q/26Q | MSMECenter',
      description: 'File quarterly TDS returns on time. Accurate computation, challan verification, and Form 16 generation for businesses.'
    },
    governmentFee: 0,
    serviceCharge: 2499,
    popular: false
  },
  {
    name: 'ESI & PF Registration',
    slug: 'esi-pf-registration',
    description: 'Register your establishment under ESIC and EPFO for mandatory employee social security compliance.',
    price: 2999,
    category: 'compliance',
    isActive: true,
    benefits: [
      'Mandatory for establishments with 10+ employees (PF) and 10+ employees with wages ≤ ₹21,000 (ESI).',
      'Employees get medical benefits, pension, and insurance coverage.',
      'Avoid prosecution and penalties for non-registration.',
      'Online filing of monthly ECR returns.',
      'Complete setup including sub-code generation for branches.'
    ],
    process: [
      { step: 1, title: 'Eligibility Assessment', description: 'Determine PF and ESI applicability based on employee count and wages. Timeline: 1 day.' },
      { step: 2, title: 'Digital Signature', description: 'Obtain DSC for authorized signatory. Timeline: 1 day.' },
      { step: 3, title: 'EPFO Registration', description: 'Register on EPFO Unified Portal and obtain establishment code. Timeline: 3-5 days.' },
      { step: 4, title: 'ESIC Registration', description: 'Register on ESIC portal and obtain employer code number. Timeline: 3-5 days.' },
      { step: 5, title: 'Employee KYC Linkage', description: 'Link all eligible employee UAN/IP numbers. Timeline: 2 days.' }
    ],
    documents: [
      'Company registration certificate',
      'PAN of company and directors',
      'Address proof of establishment',
      'Employee details (name, DOB, Aadhaar, bank account)',
      'Digital Signature Certificate of authorized signatory',
      'Cancel cheque of company bank account'
    ],
    faqs: [
      { question: 'Is PF registration mandatory?', answer: 'Yes, for all establishments with 20+ employees. Voluntary registration is allowed for establishments with 10+ employees.' },
      { question: 'What are the contribution rates?', answer: 'PF: 12% employer + 12% employee of basic wages. ESI: 3.25% employer + 0.75% employee of gross wages up to ₹21,000.' }
    ],
    seo: {
      title: 'ESI & PF Registration Online – EPFO & ESIC Setup | MSMECenter',
      description: 'Register for ESI and PF online. Complete EPFO and ESIC setup with employee KYC linkage and monthly compliance support.'
    },
    governmentFee: 0,
    serviceCharge: 2999,
    popular: false
  },
  {
    name: 'Virtual CFO Advisory',
    slug: 'virtual-cfo-advisory',
    description: 'Get a dedicated Virtual CFO — senior chartered accountant providing strategic financial planning, MIS reporting, and investor-ready financials.',
    price: 19999,
    category: 'compliance',
    isActive: true,
    benefits: [
      'Senior CA-level financial oversight at a fraction of hiring cost.',
      'Monthly MIS reports with P&L, cash flow, and ratio analysis.',
      'Fundraising support — pitch deck financials, valuation, and due diligence.',
      'Tax planning and optimization strategies.',
      'Board presentation ready financial dashboards.',
      'Budget forecasting and variance analysis.'
    ],
    process: [
      { step: 1, title: 'Onboarding & Assessment', description: 'Understand business model, revenue streams, and financial structure. Timeline: 2-3 days.' },
      { step: 2, title: 'Financial System Setup', description: 'Set up accounting systems, chart of accounts, and reporting templates. Timeline: 3-5 days.' },
      { step: 3, title: 'Monthly MIS Delivery', description: 'Deliver monthly financial reports with insights and recommendations. Timeline: Ongoing.' },
      { step: 4, title: 'Strategic Advisory', description: 'Quarterly strategy sessions covering tax planning, growth, and funding. Timeline: Quarterly.' }
    ],
    documents: [
      'Historical financial statements (2-3 years)',
      'Current accounting software access',
      'Bank statements and loan documents',
      'Business plan and growth projections'
    ],
    faqs: [
      { question: 'What is a Virtual CFO?', answer: 'A Virtual CFO is a senior chartered accountant who provides part-time CFO services remotely — financial strategy, reporting, and compliance oversight without the cost of a full-time hire.' },
      { question: 'How is this different from regular accounting?', answer: 'Accounting is backward-looking record keeping. Virtual CFO provides forward-looking financial strategy, fundraising support, and executive-level decision making.' }
    ],
    seo: {
      title: 'Virtual CFO Services for Startups & MSMEs – CA Advisory | MSMECenter',
      description: 'Hire a Virtual CFO — expert chartered accountant for MIS reports, tax planning, fundraising support & strategic financial advisory.'
    },
    governmentFee: 0,
    serviceCharge: 19999,
    popular: true
  }
];
export default servicesData;
